const apiUrl = process.env.REACT_APP_API_URL;
export const PostVariantsPlat = async ( id_plat : number, id_variacio : number, id_alternativa : number, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/plats/variants`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ id_plat, id_variacio, id_alternativa })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};